module.exports = __webpack_public_path__ + "static/media/THE CALF 4.39fca65c.jpg";